<div class="event-tags-result">
  @if (!eventTags().length) {
    <ui-no-data
      [imgSrc]="noData.imgSrc"
      [title]="noData.title | translate"
      [createButtonText]="noData.createButtonText | translate"
      (onCreate)="openCreatePanel()"
    ></ui-no-data>
  } @else {
    <div class="event-tags-result__toolbar">
      <ui-search
        [placeholder]="'EVENT_TAGS_RESULT.SEARCH' | translate"
        [searchQuery]="searchQuery()"
        (onInput)="onSearchQuery($event)"
      ></ui-search>
      <ui-button
        type="primary"
        [text]="'DATABASE.BUTTONS.CREATE_TAG' | translate"
        (clickAction)="openCreatePanel()"
      ></ui-button>
    </div>

    <!-- The quota line reports the unfiltered total, exactly like the page. -->
    <div class="event-tags-result__limit">
      {{ 'CUSTOM_EVENTS.LIMIT' | translate: { selected: eventTags().length } }}
    </div>

    @if (!filteredEventTags().length) {
      <ui-no-data [imgSrc]="noResults.imgSrc" [title]="noResults.title | translate"></ui-no-data>
    } @else {
      <div class="event-tags-result__table">
        <ui-dataset-table
          [data]="filteredEventTags()"
          [config]="tableConfig"
          (rowAction)="onRowAction($event)"
        ></ui-dataset-table>
      </div>
    }
  }
</div>
